import { h } from 'preact'

const Form = ({ onSubmit, children, ...rest }) => {
  return (
    <form
      onSubmit={e => {
        e.preventDefault()
        onSubmit(e)
      }}
      {...rest}
    >
      {children}
    </form>
  )
}

export default Form



// WEBPACK FOOTER //
// ./components/Form.js